
(function () {
  var HIDDEN = 'vmf-hidden';

  
  var DEBUG = false;
  try { DEBUG = (window.VMF_DEBUG === true) || /[?&]vmfdebug\b/.test(window.location.search); } catch (e) {}
  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[VMF]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function parseJSON(el) {
    if (!el || !el.textContent || !el.textContent.trim()) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getMap(root) {
    return parseJSON(root.querySelector('[id^="VariantMediaColorMap-"]'));
  }

  function colorList(map) {
    if (!map || !map.variants) return [];
    var seen = {}, out = [];
    Object.keys(map.variants).forEach(function (id) {
      var c = (map.variants[id] || '').trim().toLowerCase();
      if (c && !seen[c]) { seen[c] = 1; out.push(c); }
    });
    return out;
  }

  function selectedVariantId(root, map) {
    var node = root.querySelector('variant-selects [data-selected-variant]');
    var data = parseJSON(node);
    if (data && data.id != null) return String(data.id);
    var p = new URLSearchParams(window.location.search).get('variant');
    if (p) return String(p);
    if (map && map.firstVariantId != null) return String(map.firstVariantId);
    return null;
  }

  function colorForVariant(root, id) {
    var map = getMap(root);
    if (!map || !map.variants || id == null) return null;
    return map.variants[String(id)] || null;
  }


  function baseKey(v) {
    v = (v || '').trim().toLowerCase();
    if (!v) return '';
    var parts = v.split(/\s+/);
    return parts[parts.length - 1];
  }


  function assignedColor(alt, colors) {
    alt = (alt || '').trim().toLowerCase();
    var best = null, bestLen = -1;
    for (var i = 0; i < colors.length; i++) {
      var full = colors[i];
      var key = baseKey(full);
      if (full && alt.indexOf(full) === 0 && full.length > bestLen) { best = key; bestLen = full.length; }
      if (key && alt.indexOf(key) === 0 && key.length > bestLen) { best = key; bestLen = key.length; }
    }
    return best;
  }

  function syncActive(root) {
    var thumbs = root.querySelectorAll('.gallery-slider--thumbnail');
    var first = null;
    thumbs.forEach(function (t) {
      if (!first && !t.classList.contains(HIDDEN)) first = t;
    });
    if (first) {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      first.classList.add('active');
    }
    var con = root.querySelector('#SlidesCon');
    if (con) con.scrollLeft = 0;
  }


  function syncLayout(root) {
    var comp = root.querySelector('.product-media-component');
    var con = root.querySelector('#SlidesCon');
    if (!comp || !con) return;

    var gridImgs = [];
    for (var i = 0; i < con.children.length; i++) {
      var c = con.children[i];
      if (c.classList && c.classList.contains('product-media-image')) gridImgs.push(c);
    }
    var visible = gridImgs.filter(function (c) { return !c.classList.contains(HIDDEN); });
    var n = visible.length;
    if (!n) return;

    comp.className = comp.className.replace(/\bproduct-media-qty-\d+\b/g, ' ').replace(/\s+/g, ' ').trim();
    comp.classList.add('product-media-qty-' + n);
    comp.classList.remove('grid-layout-even', 'grid-layout-odd');
    comp.classList.add(n % 2 === 0 ? 'grid-layout-even' : 'grid-layout-odd');
    comp.classList.add('grid-balance-true');

    // Make the first visible image the actual first child so :first-child rules hit it.
    if (con.firstElementChild !== visible[0]) {
      con.insertBefore(visible[0], con.firstElementChild);
    }
  }

  function applyFilter(root, color) {
    var colors = colorList(getMap(root));
    var target = color ? baseKey(color) : null;
    var shown = 0, hidden = 0;
    root.querySelectorAll('[data-media-alt]').forEach(function (el) {
      var alt = (el.getAttribute('data-media-alt') || '').trim().toLowerCase();
      var assigned = assignedColor(alt, colors);
      var show = !target || assigned === target;
      el.classList.toggle(HIDDEN, !show);
      if (show) { shown++; } else { hidden++; }
    });
    log('applyFilter', { selectedColor: target, knownColors: colors, shown: shown, hidden: hidden });
    syncActive(root);
    syncLayout(root);
  }

  function initRoot(root) {
    var map = getMap(root);
    applyFilter(root, colorForVariant(root, selectedVariantId(root, map)));
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' ||
        typeof PUB_SUB_EVENTS === 'undefined' ||
        !PUB_SUB_EVENTS.variantChange) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      var d = (evt && evt.data) || {};
      var root = (d.sectionId && document.querySelector('product-info[data-section="' + d.sectionId + '"]'))
        || document.querySelector('product-info');
      if (!root) return;
      var color = d.variant ? colorForVariant(root, d.variant.id) : null;
      log('variantChange', { variantId: d.variant && d.variant.id, color: color });
      applyFilter(root, color);
    });
    log('subscribed to variantChange');
    return true;
  }

  function init() {
    document.querySelectorAll('product-info').forEach(function (root) {
      var map = getMap(root);
      log('init', map ? { firstVariantId: map.firstVariantId, colors: colorList(map) } : 'no map found');
      if (DEBUG && map && !colorList(map).length) {
        console.warn('[VMF] no colors in map — Color option name not matched. Check vmf_color_names in the snippet.');
      }
    });
    document.querySelectorAll('product-info').forEach(initRoot);
    // subscribe / PUB_SUB_EVENTS may not be ready on the first tick; retry briefly.
    if (!bindPubSub()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (bindPubSub() || tries > 20) clearInterval(timer);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();